import { render, staticRenderFns } from "./retrievePwd.vue?vue&type=template&id=c1e698b0&scoped=true&"
import script from "./retrievePwd.vue?vue&type=script&lang=js&"
export * from "./retrievePwd.vue?vue&type=script&lang=js&"
import style0 from "./retrievePwd.vue?vue&type=style&index=0&id=c1e698b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e698b0",
  null
  
)

export default component.exports